import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/closing';
export function PainPoints() {
  return <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-90" data-mp="2lp54sq5qh0t5">
      <div className="mx-auto max-w-4xl" data-id="element-91" data-mp="26xmu97vn7yh6">
        <header className="text-center" data-id="element-92" data-mp="26wldqnvuyjs2">
          <h2 className="font-display text-3xl font-bold sm:text-4xl" data-id="element-93" data-mp="2bwhac22878xl">
            ¿CUÁNTAS VECES MÁS VAS A LLEGAR A LA HORA DE COMER SIN SABER QUÉ PREPARAR?
          </h2>
        </header>
        <div className="mt-10 space-y-3" data-id="element-94" data-mp="21zla0jmhdt44">
          {painPoints.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-danger-border/70 bg-danger-surface p-4 sm:p-5" data-id="element-95" data-mp="1nztpe01gleh5" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-96" data-mp="3nc5z8yz1ii11" />
              <p className="text-sm leading-relaxed text-foreground-soft sm:text-base" data-id="element-97" data-mp="1yz3w4w4800fs">
                {point}
              </p>
            </motion.div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-98" data-mp="27t8j34g8grq1">
          <p className="text-lg text-foreground-muted" data-id="element-99" data-mp="27s74wr3x7p43">No es que te falten recetas.</p>
          <p className="mt-2 text-lg font-semibold text-primary-soft" data-id="element-100" data-mp="23rx0vjzov8rv">
            Te falta un sistema para organizar todas esas decisiones.
          </p>
        </div>
        <p className="mx-auto mt-10 max-w-3xl text-center font-display text-2xl font-bold italic text-highlight sm:text-3xl" data-id="element-101" data-mp="1b3hqjari5emv">
          ¿Y si pudieras convertir una sesión de planificación y preparación en una reserva de comidas y componentes listos para ayudarte durante la semana?
        </p>
      </div>
    </section>;
}